import { useEffect } from 'react';
import { Text } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import { CardScreen } from '@/components/common/CardScreen';
import star from '@/assets/star.png';
import { t } from '@/strings/index';
import { logScreenRender } from '@/telemetry/telemetryEvents';
import { ROUTES } from '@/constants/routes';

export default function FeedbackSubmittedScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    // Log screen view
    logScreenRender('FeedbackSubmittedScreen');
  }, []);

  const handleStartOver = () => {
    // Clear session storage and navigate to welcome screen
    sessionStorage.clear();
    navigate(ROUTES.HOME);
  };

  return (
    <CardScreen
      title={t('feedbackThanks.message')}
      primaryButtonText={t('feedbackThanks.startOver')}
      onPrimaryButtonClick={handleStartOver}
      showBackButton={false}
      showUserInfo={false}
      showLogo={false}
    >
      <img
        src={star}
        alt=""
        style={{ width: 192, height: 192, margin: '16px auto', display: 'block' }}
      />
      <Text style={{ textAlign: 'center', fontSize: 14, color: '#242424', lineHeight: '20px', marginBottom: '8px' }}>
        {t('feedbackThanks.submittedMessage')}
      </Text>
    </CardScreen>
  );
}
